import React from "react";
import { Form } from "semantic-ui-react";

import ControlTranslationIdLabel from "../../../../../components/control_translation_id_label";
import AutoLinkTextarea from "../../../../../components/autolink_textarea/autolink_textarea";
import { TranslationDetails } from "../../../../../components/translation_modal/translation_details";
import EditTranslationModalTags from "./edit_translation_modal_tags";

import { getText } from "../../../../../helpers";

const formTranslatedLabels = {
  spanish: {
    title: "Título",
    subtitle: "Subtítulo",
    description: "Descripción",
  },
  portuguese: {
    title: "Título",
    subtitle: "Subtítulo",
    description: "Descrição",
  },
  turkish: {
    title: "Başlık",
    subtitle: "Altbaşlık",
    description: "Tanım",
  }
};

export default function EditTranslationModalContent(props) {
  const { isLoading, control, language, currentLanguage, translation, editedTranslation, onTranslationChange } = props;

  const subLabel = formTranslatedLabels[language.value.toLowerCase()];
  const isAiTranslation = translation.translation_type === "ai";
  const aiTranslation = isAiTranslation ? translation : translation.ai_translation || {};
  const manualTranslation = !isAiTranslation ? translation : null;

  return (
    <div className="edit-translation-content">
      <label>{currentLanguage.text}</label>
      <div className="translation-section">
        <TranslationDetails translation={translation.translation_source} control={control} />
      </div>
      <br />
      <label>{language.text}</label>
      <Form className="translation-section">
        <ControlTranslationIdLabel translation={translation} />
        <TranslationDetails translation={aiTranslation.translation_result} control={control} />
      </Form>
      <br />
      <fieldset disabled={isLoading}>
        <label className="text-blue">{getText("Manual Translation Update")} - {language.text}</label>
        <ControlTranslationIdLabel translation={manualTranslation} />
        <Form className="translation-section">
          <Form.Field>
            <label>{getText("Title")} ({subLabel.title})</label>
            <input name="title" placeholder={getText("Title")} value={editedTranslation.title} onChange={onTranslationChange} />
          </Form.Field>
          <Form.Field>
            <label>{getText("Subtitle")} ({subLabel.subtitle})</label>
            <input name="subtitle" placeholder={getText("Subtitle")} value={editedTranslation.subtitle} onChange={onTranslationChange} />
          </Form.Field>
          <Form.Field>
            <label>{getText("Description")} ({subLabel.description})</label>
            <AutoLinkTextarea name="description" placeholder={getText("Description")} value={editedTranslation.description} onChange={onTranslationChange} />
          </Form.Field>
        </Form>
        <br />
        <Form>
          <Form.Field>
            <EditTranslationModalTags editedTranslation={editedTranslation} onTranslationChange={onTranslationChange} />
          </Form.Field>
          <Form.Field>
            <label>{getText("Notes (including detail of: translation author and date: approval manager and date)")}</label>
            <AutoLinkTextarea name="notes" placeholder={getText("Notes")} value={editedTranslation.notes} onChange={onTranslationChange} />
          </Form.Field>
        </Form>
      </fieldset>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/control_library/table/tanslations_modal/edit_translation_modal/edit_translation_modal_content.js